import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { wsGetAll } from 'services/WService.js';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default WithApp(function ModalCuotaSede(props) {
  const cuota = props.model;
  const [dataChanging, setDataChanging] = useState([]);
  const [zones, setZones] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  useEffect(() => {
    if (cuota.open) {
      listZones();
    }
  }, [cuota.open]);

  useEffect(() => {
    if (zones.length > 0 && cuota.codsede) {
      handleChange("codsede", String(cuota.codsede));
    }
  },[zones]);

  return (
    <>
      <Modal
        title={`Nueva Cuota de Sede para Verdum`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/cuota-sede'
        dataForce={
          {
            codsede: dataChanging.codsede
          }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <Autocomplete
          disableClearable
          options={zones}
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Sede" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {handleChange('codsede', item?.code);}}
          value={zones.find((zone) => String(zone.code) === String(dataChanging.codsede)) || null }
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Tipo</InputLabel>
          <Select
            required
            defaultValue={!!cuota ? cuota.tipo : ''}
            inputProps={{
              name: 'tipo',
            }}
          >
            <MenuItem value="O">Venta</MenuItem>
            <MenuItem value="I">Compra</MenuItem>
            <MenuItem value="C">Cobertura</MenuItem>
          </Select>
        </FormControl>
        <TextField
          label="Cuota"
          fullWidth
          type="number"
          name="cuota"
          margin="normal"
          defaultValue={!!cuota ? cuota.cuota : ''}
          onChange={(e) => handleChange('cuota', e.target.value)}
          required
        />
      </Modal>
    </>
  );
});

